export function hexToRgbString(hex: string, alpha?: number) {
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i
  const transform = hex.replace(shorthandRegex, function (_, r, g, b) {
    return r + r + g + g + b + b
  })

  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(transform)

  return result && result[1] && result[2] && result[3]
    ? `rgb(${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}${
        alpha != null && `, ${alpha}`
      })`
    : ''
}
